var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('HeroSection'),_c('AgentsSection'),_c('WorkflowSection'),_c('FeaturesSection'),_c('VideoSection'),_c('FooterBanner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }